module.exports = __webpack_public_path__ + "static/media/fruttivendolo profilo.a4d66055.svg";